import { forwardRef, Ref, type SVGProps } from 'react';

const SvgRefreshCcwIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1.333 6.667S2.67 4.845 3.756 3.759a6 6 0 1 1-1.521 5.908m3.098-3h-4v-4"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRefreshCcwIcon);
export default ForwardRef;
